import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { chipColors } from '../../lib/contrast';

type EventType = 'NORMAL' | 'TOURNAMENT';

type Props = {
    type: EventType;
};

/**
 * Chip event type
 */
export function SttChipEventType({ type }: Props): React.ReactElement {
    const { t } = useTranslation();

    const color: Record<EventType, string> = {
        NORMAL: '#3186a7',
        TOURNAMENT: '#a341bb',
    };

    return (
        <>
            {type && (
                <Chip
                    size="small"
                    label={t(`eventTypes.${type.toLowerCase()}`)}
                    style={{ ...chipColors(color[type]) }}
                />
            )}
        </>
    );
}
